export const SAVE_XML_PATH = "https://shuntlogik.prema.se/nodeapp/savexml";
export const SAVE_XML_PATH_LOCAL = "http://localhost:3050/savexml";
//export const SAVE_XML_PATH_DOCKER = "https://laptop-6u9qqdsq:32902/savexml";
export const SAVE_XML_PATH_DOCKER = "http://192.168.86.239:32903/savexml";